module.exports = __webpack_public_path__ + "img/wallace-welding-logo.86e25779.jpg";